import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TabRoutes } from '../modals/tab-routes.enum';
import { HttpClient } from '@angular/common/http'; // 👈 to call API
import { FileUploadResult } from '../file-upload/file-upload.component';
import { SharedDataService } from '../shared-data.service';

@Component({
  selector: 'app-issuance-code-certificate',
  templateUrl: './issuance-code-certificate.component.html',
  styleUrls: ['./issuance-code-certificate.component.scss'],
})
export class IssuanceCodeCertificateComponent implements OnInit, OnDestroy {
  documentForm: FormGroup;
  filePath: string;
  isSubmitting = false;
  @Input() existingFileUrl: string = ''; // Add this input

  @Output() issuanceCode = new EventEmitter<string>();
  private subscriptions: Subscription[] = [];
  isReadOnly: boolean = false; // Default to readonly (no note)

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private sharedData: SharedDataService
  ) {
    this.documentForm = this.fb.group({
      idDocument: [null, Validators.required], // Required file
    });
    this.filePath = TabRoutes.PreEstablishment;
  }

  ngOnInit(): void {
    // Subscribe to noteSections from SharedDataService (wizard updates it via getNotes())
    const noteSub = this.sharedData.noteSections$.subscribe(
      (noteSections: string[]) => {
        const stepCode = 'PRE_FOUNDATION'; // Matches wizard's step code for pre-establishment
        const hasNote = noteSections.includes(stepCode);
        const status = this.sharedData.getRequestStatus();
        if (status === 'PENDING_EDIT') {
          if (hasNote === true) {
            this.isReadOnly = false;
          } else {
            this.isReadOnly = true;
          }
        } else if (status === 'DRAFT') {
          this.isReadOnly = false;
        } else if (status === '') {
          this.isReadOnly = false;
        } else {
          this.isReadOnly = true;
        }
        // Re-validate form if switching to editable mode
        if (!this.isReadOnly) {
          this.documentForm.markAsUntouched();
        }
        console.log(
          '📝 PRE_FOUNDATION readonly (issuance code):',
          this.isReadOnly
        );
      }
    );
    this.subscriptions.push(noteSub);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['existingFileUrl'] && changes['existingFileUrl'].currentValue) {
      console.log(
        '🔄 Existing file URL received (issuance code):',
        this.existingFileUrl
      );
      this.documentForm.patchValue({
        idDocument: this.existingFileUrl,
      });
    }
  }

  // ✅ Handle Save
  onSave() {
    if (this.isReadOnly) return; // Guard in readonly mode
    if (this.documentForm.invalid) {
      this.documentForm.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;

    const file: File = this.documentForm.get('idDocument')?.value;
    const formData = new FormData();
    formData.append('idDocument', file);
    formData.append('filePath', this.filePath);
  }
  onUploadComplete(event: any) {
    if (this.isReadOnly) return; // Guard in readonly mode
    const filePath = event?.url || '';
    this.issuanceCode.emit(filePath);
  }
  onFileRemoved() {
    if (this.isReadOnly) return; // Guard in readonly mode
    const filePath = '';
    this.issuanceCode.emit(filePath);
  }
}
